import React, { useState, useEffect } from "react";
import { FaUserCheck, FaBuilding, FaBan } from "react-icons/fa";
import AdminHeader from "./AdminHeader"; // Import the AdminHeader component
import ArenaRequests from "./ArenaRequests";
import RegisteredArenas from "./RegisteredArenas";
import DisabledArenas from "./DisabledArenas";

const ArenaAdminDashboard = () => {
  const [activeTab, setActiveTab] = useState("requests");
  const [registeredArenas, setRegisteredArenas] = useState([]);
  const [disabledArenas, setDisabledArenas] = useState([]);

  const handleDisableArena = (arena) => {
    setDisabledArenas([...disabledArenas, arena]);
    setRegisteredArenas(registeredArenas.filter((a) => a.id !== arena.id));
  };

  const handleEnableArena = (arena) => {
    setRegisteredArenas([...registeredArenas, { ...arena, status: "active" }]);
    setDisabledArenas(disabledArenas.filter((a) => a.id !== arena.id));
  };

  const renderContent = () => {
    switch (activeTab) {
      case "requests":
        return <ArenaRequests />;
      case "registered":
        return <RegisteredArenas onDisableArena={handleDisableArena} />;
      case "disabled":
        return <DisabledArenas onEnableArena={handleEnableArena} />;
      default:
        return <ArenaRequests />;
    }
  };

  const baseTabButton =
    "bg-[#f0f0f0] border-0 px-5 py-2.5 text-[16px] cursor-pointer flex items-center transition-colors duration-300 rounded hover:bg-[#e6e6e6] w-full md:w-auto";
  const activeTabButton = "bg-[#3498db] text-white hover:bg-[#3498db]";

  return (
    <div className="min-h-screen bg-[#f0f2f5]">
      <AdminHeader />
      <div className="max-w-[1200px] mx-auto p-5">
        <h2 className="text-center text-[#333] mb-5 text-2xl">Admin Dashboard</h2>
        <div className="flex flex-col md:flex-row md:justify-around gap-2 md:gap-0 mb-5">
          <button
            className={`${baseTabButton} ${activeTab === "requests" ? activeTabButton : ""}`}
            onClick={() => setActiveTab("requests")}
          >
            <FaUserCheck className="mr-2" /> Arena Requests
          </button>
          <button
            className={`${baseTabButton} ${activeTab === "registered" ? activeTabButton : ""}`}
            onClick={() => setActiveTab("registered")}
          >
            <FaBuilding className="mr-2" /> Registered Arenas
          </button>
          <button
            className={`${baseTabButton} ${activeTab === "disabled" ? activeTabButton : ""}`}
            onClick={() => setActiveTab("disabled")}
          >
            <FaBan className="mr-2" /> Disabled Arenas
          </button>
        </div>
        <div className="bg-white rounded-[8px] shadow-[0_2px_4px_rgba(0,0,0,0.1)] p-5">
          {renderContent()}
        </div>
      </div>
    </div>
  );
};

export default ArenaAdminDashboard;
